export default {
  apiKey: "AIzaSyAhsxAv-niLxlUI9YgkEjGJ-BY32qhgMLk",
  authDomain: "gta-testing-b9ae2.firebaseapp.com",
  databaseURL: "https://gta-testing-b9ae2.firebaseio.com",
  projectId: "gta-testing-b9ae2",
  storageBucket: "gta-testing-b9ae2.appspot.com",
  messagingSenderId: "18557426154",
  appId: "1:18557426154:web:9c1abebdbd4e88c2d2fa93"
};
